import React from 'react';
import copy from 'fast-copy';
import { useTranslation } from 'react-i18next';
import { Button, Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';

import './Module.css';
import { colors } from '../../../../../Shared/utils';
import { getModuleConditions, getModuleLines } from '../../../../../Functions/utils';


export default function ModuleWithSequence({ line, nb, setModule, handleChangeLine, handleRemoveLine, newSeq }) {

  // console.log("------------------------------- ModuleWithSequence");
  // console.log("12 - line=", line);
  // console.log("13 - newSeq=", newSeq);
  console.log("14 - module=", module);
  // console.log("15 - nb=", nb);

  module = line.module;

  if (module && module.newModule) {
    module.newModule = false;

    const tmpModule = copy(module);
    setModule(tmpModule)
  }

  const { t } = useTranslation();

  const wholeModuleAbsent = module && module.conditions && module.conditions[0] &&
    module.conditions[0].seq === 1 && module.conditions[0].xtra_desc === "FAKE_XTRA_DESC_FOR_WHOLE_MODULE_ABSENT";


  console.log("34 - module=", module);
  const lines = getModuleLines(module.conditions);

  return (
    <div
      className='module open'
      style={{ marginTop: '10px', width: '100%' }}
    >

      <div
        className="module__condition"
        style={{ margin: "0px" }}
      >

        <select
          className="singleSelect"
          name={'operator' + line.seq}
          value={line.extra ?? '0'}
          onChange={e => handleChangeLine(line, 'extra', e.target.value)}
          disabled={line.extra === ''}
        >
          {/* <option hidden value="0">{t('scenarios.conditions.operator')}</option> */}
          {line.extra === '' &&
            <option value="">{''}</option>
          }
          <option value="OR">{t('scenarios.conditions.operators.OR').replace(/(\u2000)/g, '')}</option>
          <option value="AND">{t('scenarios.conditions.operators.AND').replace(/(\u2000)/g, '')}</option>
        </select>

        <select
          className="singleSelect"
          name={'leftP' + line.seq}
          value={line.first ?? '0'}
          onChange={e => handleChangeLine(line, 'first', e.target.value)}
        >
          <option value="0">{''}</option>
          <option value="1">{'﴾'}</option>
          <option value="2">{'﴾﴾'}</option>
          <option value="3">{'﴾﴾﴾'}</option>
        </select>


        <div className="module__title">
          <h3 style={{ color: newSeq ? colors.softthinks : 'inherit' }}>
            {t('scenarios.modules.' + module.moduleId)}
          </h3>
        </div>

        <div
          className="module__options"
        >

          {module.conditions.length > 0 ? (
            <>
              {getModuleConditions(t, module.conditions).text}
            </>
          ) : (
            <h4 style={{ color: colors.warning }}>{t('scenarios.conditions.none')}.</h4>
          )}

          <select
            className="singleSelect"
            name={'leftP' + line.seq}
            value={line.last ?? '0'}
            onChange={e => handleChangeLine(line, 'last', e.target.value)}
          >
            <option value="0">{''}</option>
            <option value="1">{'﴿'}</option>
            <option value="2">{'﴿﴿'}</option>
            <option value="3">{'﴿﴿﴿'}</option>
          </select>

          <div className="module__actions">
            <Button
              className="button icon"
              title={t('scenarios.modules.edit')}
              onClick={() => setModule(copy(line.module))}
            >
              <span className="material-icons-outlined">edit</span>
            </Button>

            <Button
              className="button icon remove"
              title={t('scenarios.modules.remove')}
              onClick={() => handleRemoveLine(line)}
            >
              <span className="material-icons-outlined" style={{ fontSize: '22px' }}>
                remove_circle_outline
              </span>
            </Button>
          </div>
        </div>
      </div>
    </div >
  );
}
